<div class="preview-pane" #pane>
  @if (preview?.html) {
    <div
      class="preview-scale-slot"
      [style.width.px]="scaledWidthPx"
      [style.height.px]="scaledHeightPx"
    >
      <div
        class="preview-stage"
        [style.transform]="'scale(' + scale + ')'"
      >
        <iframe
          #mainFrame
          class="preview-frame"
          title="Etikettenvorschau"
          src="about:blank"
          [style.width]="preview.widthMm + 'mm'"
          [style.height]="preview.heightMm + 'mm'"
          (load)="onFrameLoad()"
        ></iframe>
        @if (hasCompanion) {
          <iframe
            #companionFrame
            class="preview-frame"
            title="Zutatenetikett"
            src="about:blank"
            [style.width]="(preview.companionWidthMm || 58) + 'mm'"
            [style.height]="(preview.companionHeightMm || 58) + 'mm'"
            (load)="onFrameLoad()"
          ></iframe>
        }
      </div>
    </div>
  } @else if (loading) {
    <nz-spin nzSimple></nz-spin>
  } @else {
    <nz-empty nzNotFoundContent="Keine Vorschau"></nz-empty>
  }
</div>
